import React, { useCallback } from 'react'

import { publishEvent } from '@zet/analytics'
import { APP_SESSION } from '@zet/constants'
import { B2, Pressable } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { i18n } from '@zet/localization'
import { UpdatesModule } from '@zet/utils'
import { navigateTo } from '@zet/utils/navigation'
import { reloadAsync } from 'expo-updates'

import { LiveCampaignStrip } from './liveCampaignStrip'

const OtaStrip = () => {
  const { isReloadable } = UpdatesModule.useUpdatesAvailable()

  const handleUpdate = async () => {
    publishEvent('click_action', {
      item_name: 'apply_ota_update',
    })
    APP_SESSION.setReloadType('UPDATE_RELOAD')
    await reloadAsync()
  }

  const handleCampaignNavigate = useCallback(() => {
    navigateTo('MagnetBenefits')
  }, [])

  if (isReloadable) {
    return (
      <Stack className="bg-success-100 p-2">
        <Pressable
          onPress={handleUpdate}
          className="flex-row items-center space-x-2 self-center"
        >
          <B2 className="text-neutral-white100">{i18n.t('applyOta')}</B2>
        </Pressable>
      </Stack>
    )
  }

  return (
    <LiveCampaignStrip
      showStrip={true}
      msg={i18n.t('offerCampaign.message')}
      onPress={handleCampaignNavigate}
    />
  )

  return <></>
}

export default OtaStrip